module.exports = __webpack_public_path__ + "static/media/lp7.682b429c.jpg";